
import { Options } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import { ClientApi, GetHrCriterion, StatsApi } from "../../autogen";
import { SelectableProfile, GetProfile } from "../../types";
import Page from "../molecules/Page.vue";
import ActionButton from "../atoms/ActionButton.vue";
import Table from "../molecules/Table.vue";
import UIkit from "uikit";
import HrCriterionForm from "../organisms/HrCriterionForm.vue";
import SearchField from "../atoms/SearchField.vue";
import ChartViewMixin from "../../helpers/mixins/chart-view";
import UserSelector from "../molecules/UserSelector.vue";
import DepartmentUserSelector from "../organisms/DepartmentUserSelector.vue";
import FieldLabel from "../atoms/FieldLabel.vue";
import HelpIcon from "../atoms/HelpIcon.vue";
import Store from "../../store";

@Options({
  components: {
    Page,
    ActionButton,
    Table,
    HrCriterionForm,
    SearchField,
    UserSelector,
    DepartmentUserSelector,
    FieldLabel,
    HelpIcon
  }
})
export default class HrCriteria extends ChartViewMixin {
  private readonly storeInstance = Store.getInstance();
  mode: "result" | "manage" = "manage";
  participantsMin = 1;
  participantsMax = 100;
  criteria: GetHrCriterion[] = [];
  criterion: GetHrCriterion | null = null;
  selectedUsers: SelectableProfile[] = [];
  selectedCriteriaIds: string[] = [];
  departmentUserSelectorFormKey = 0;
  formKey = 0;
  header = [
    { title: "人材基準名", sortable: true, key: "name", width: "expand" },
    { title: "編集", type: "button", key: "edit", width: 150 }
  ];
  filterColumns = ["name"];
  modalRef!: HTMLElement;
  query = "";
  renewKey = 0;

  private async loadData() {
    const response = await new ClientApi().getHrCriteria({});
    this.criteria = response.data;
    this.renewKey = Date.now();
  }
  mounted() {
    this.$nextTick(() => {
      this.modalRef = this.$refs.modalRef as HTMLElement;
    });
  }

  async beforeMount() {
    await this.loadData();
  }
  beforeUnmount() {
    if (this.modalRef) this.modalRef.remove();
  }
  get disableDownload(): boolean {
    return this.selectedUsers.length === 0 || this.selectedCriteriaIds.length === 0;
  }
  onAddCriteria() {
    this.formKey = Date.now();
    this.criterion = null;
    UIkit.modal(this.modalRef).show();
  }
  async onSubmitted() {
    UIkit.modal(this.modalRef).hide();
    await this.loadData();
  }
  async onSearch(searchResult: [] | null) {
    if (searchResult) {
      this.criteria = searchResult;
    } else {
      await this.loadData();
    }
  }
  onColumnClick(location: { row: number; col: string }) {
    if (location.col === "edit") {
      this.criterion = this.criteria[location.row];
      this.formKey = Date.now();
      UIkit.modal(this.modalRef).show();
    }
  }
  userSelect() {
    this.onSelectionDoneButtonClick();
  }
  async onDownload() {
    Store.getInstance().setIsLoading(true);
    const response = await new StatsApi().getCriteriaJudgmentResults(
      {
        peopleIds: this.selectedUsers.map(user => user.id).join(","),
        criteriaList: this.selectedCriteriaIds.join(",")
      },
      { responseType: "arraybuffer" }
    );
    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `人材基準判定_${new Date().toISOString()}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    Store.getInstance().setIsLoading(false);
  }
}
